<style type="text/css">

.overview-stats-card{
	background: #FFFFFF;
	box-shadow: 0px 5px 10px rgba(157, 149, 149, 0.25);
	border-radius: 25px !important;
	padding: 0px 10px 5px 10px;
	color: #1DC895;
	margin-bottom:10px;
}
</style>
<template>
	<div>
		<v-row class="">
			<!--  total shipments -->
			<v-col cols="6" md="3" class="px-2" >
				<v-card class="overview-stats-card mx-1 cursor-pointer btn-whithout-hover" @click="$router.push({name:'shipments'})" >
					<div class="d-flex flex-row" flat >
						<v-card class="pa-2 mt-1 w-60 v-align-middle" flat >
							<p class="sub-title-text fs-36">{{status_counts.total_shipment}}</p>
							<p class="over-view-text">{{$lang.TOTAL}}</p>
						</v-card>
						<v-card flat class="w-40 v-align-middle text-right" >
							<img src="@/assets/warehouse-overview/total.svg"  alt="img"  height="56px" class="mt-5 mr-2">
						</v-card>
					</div>
				</v-card>
			</v-col>

			<!--  At ware house -->
			<v-col cols="6" md="3" class="px-2" >
				<v-card class="overview-stats-card mx-1 cursor-pointer btn-whithout-hover" @click="$router.push({name:'shipments',query:{shipment_status:encript([$keys.DROPPED_AT_WAREHOUSE,$keys.ON_HOLD,$keys.RETURN,$keys.PARTIAL_RETURN,$keys.DROPPED_AT_WAREHOUSE_RETURN])}})" >
					<div class="d-flex flex-row py-0" flat >
						<v-card class="pa-2 mt-1 w-60 v-align-middle" flat >
							<p class="sub-title-text fs-36 ">{{status_counts.at_warehouse}}</p>
							<p class="over-view-text">{{$lang.AT_WAREHOUSE}}</p>
						</v-card>
						<v-card flat class="w-40 v-align-middle text-right" >
							<img src="@/assets/warehouse-overview/at-warehouse.svg"  alt="img"  height="56px" class="mt-5 mr-2">
						</v-card>
					</div>
				</v-card>
			</v-col>

			<!--  At ware house -->
			<v-col cols="6" md="3" class="px-2" >
				<v-card class="overview-stats-card mx-1 cursor-pointer btn-whithout-hover" @click="$router.push({name:'shipments',query:{shipment_status:encript($keys.OUT_FOR_DELIVERY)}})" >
					<div class="d-flex flex-row py-0" flat >
						<v-card class="pa-2 mt-1 w-60 v-align-middle" flat >
							<p class="sub-title-text fs-36 ">{{status_counts.out_for_delivery_count}}</p>
							<p class="over-view-text">{{$lang.OUT_FOR_DELIVERY}}</p>
						</v-card>
						<v-card flat class="w-40 v-align-middle text-right" >
							<img src="@/assets/warehouse-overview/out-for-delivery.svg"  alt="img"  height="56px" class="mt-5 mr-2">
						</v-card>
					</div>
				</v-card>
			</v-col>


			<!--  At ware house -->
			<v-col cols="6" md="3" class="px-2" >
				<v-card class="overview-stats-card mx-1 cursor-pointer btn-whithout-hover" @click="$router.push({name:'shipments',query:{shipment_status:encript($keys.DELIVERED)}})" >
					<div class="d-flex flex-row py-0" flat >
						<v-card class="pa-2 mt-1 w-60 v-align-middle" flat >
							<p class="sub-title-text fs-36 ">{{status_counts.delivered_count}}</p>
							<p class="over-view-text">{{$lang.DELIVERED}}</p>
						</v-card>
						<v-card flat class="w-40 v-align-middle text-right" >
							<img src="@/assets/warehouse-overview/delivered.svg"  alt="img"  height="56px" class="mt-5 mr-2">
						</v-card>
					</div>
				</v-card>
			</v-col>

		</v-row>
	</div>
</template>
<script type="text/javascript">
export default{
	props:["status_counts"]
}
</script>